var $ = jQuery;

(function($) {
	"use strict";


	$(document).ready(function() {

        $('#print-include-images').on('click', function () {
            $('#print-options').modal('hide');
            javascript:window.print();
        });

        $('#print-exclude-images').on('click', function () {
            $('body').addClass('print-no-images');
            $('#print-options').modal('hide');
            javascript:window.print();
            $('body').removeClass('print-no-images');
        });


        /**
         * Toggle off canvas navigation
         */
        $('[data-toggle="offcanvas-bottom"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            offcanvas(target, 'bottom');

            // Fix scrolling issues on iOS
            var showMenu = $(target).hasClass('active');
            if(showMenu) {
                disableBodyScroll();
            } else {
                enableBodyScroll();
            }

        });

        function offcanvas(target, dir) {

            $(target).toggleClass('active');
            $('body').toggleClass('offcanvas-active-' + dir);

            /**
             * Add class to body to indicate that offcanvas is animating in or out.
             */
            $('body').addClass('offcanvas-animating-' + dir);
            $(target).on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
                $('body').removeClass('offcanvas-animating-' + dir);
            });

        }

        /**
         * Toggle for search mobile view
         */
        $('[data-toggle="search"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            $(target).toggleClass('active');
            $('body').toggleClass('search-active');
            $('#search-input').focus();
        });

		var search_is_showing = false;
        var search_trigger = document.getElementById('search-trigger');
		$('#search-trigger').click(function (e) {
			if (!search_is_showing) {
                search_trigger.setAttribute('aria-expanded', 'true');
                $('#search-hidden-wrapper input').removeClass('hidden').focus();
				search_is_showing = true;

			} else {
                search_trigger.setAttribute('aria-expanded', 'false');
				$('#search-hidden-wrapper input').addClass('hidden');
				search_is_showing = false;
			}

		});



        $('.post-filter .dropdown-menu li a').click(function(){
            var selValue = $(this).data('value');
            var selText = $(this).text();

            if( selValue === 'false' ){
                $(this).parents('.btn-group').find('.category').val('');
            }else{
                $(this).parents('.btn-group').find('.category').val(selValue);
                $(this).parents('.btn-group').find('.dropdown-toggle').html(selText+' <span class="caret"></span>');
            }


        });

        $(document).ready(function(){
            $('.mega-menu-trigger').click(function(){
                $(this).find('.mega-menu-trigger__icon').toggleClass('open');
            });
        });


        $('.collapse').on('hide.bs.collapse', function () {
            $(this).closest('.card').find('.card-header__toggle').removeClass('shown');
            $(this).closest('.card').find('.card-header__toggle').addClass('closed');
            //alert('hide');

        });

        $('.collapse').on('show.bs.collapse', function () {
            $(this).closest('.card').find('.card-header__toggle').removeClass('closed');
            $(this).closest('.card').find('.card-header__toggle').addClass('shown');
            //alert('show');

        });






        $('.top-search input').on('focus', function () {
            $(this).closest('.input-group').find('.btn').show();

            $(this).closest('.input-group').stop().animate({
                width:'80%'
            },600);

        });


        $('#collapse-search').on('hidden.bs.collapse', function () {

            $('.top-search input').closest('.input-group').stop().animate({
                width:'40%'
            },600);

            $('.top-search input').closest('.input-group').find('.btn').hide();

        });


        $('#searcher').on('click', function (e) {

            var searchfield = $(this).closest('.navbar-actions').find('input');

            if ($(this).hasClass('open')) {

                $(this).removeClass('open');
                $(this).addClass('closed');

                searchfield.stop().animate({
                    width:'0'
                },100, function() {
                    searchfield.hide();
                });


            } else {
                $(this).addClass('open');
                $(this).removeClass('closed');
                searchfield.show();

                searchfield.stop().animate({
                    //display: 'block',
                    width:'100%'
                },100, function () {
                    searchfield.focus();
                });

            }

            return false;
/*

             setTimeout(function(){
             $(this).closest('.input-group').find('.btn').hide();

             }, 1000);

             if(e.relatedTarget && e.relatedTarget.type === 'submit'){
             alert('asdfa');
             return false;
             }
*/
             });


/*
        $('.top-search input').on('blur', function (e) {

            $(this).closest('.input-group').stop().animate({
                width:'40%'
            },200, function() {
                $(this).closest('.input-group').find('.btn').hide();
            });

            /*
            setTimeout(function(){
                $(this).closest('.input-group').find('.btn').hide();

            }, 1000);

            if(e.relatedTarget && e.relatedTarget.type === 'submit'){
                alert('asdfa');
                return false;
            }

        });

*/
/*

        $('.site-header').data('size','big');


        $(window).scroll(function(){
            if($(document).scrollTop() > 0)
            {
                if($('.site-header').data('size') == 'big')
                {
                    $('.site-header').data('size','small');
                    $('.site-header').stop().animate({
                        height:'40px'
                    },600);
                }
            }
            else
            {
                if($('.site-header').data('size') == 'small')
                {
                    $('.site-header').data('size','big');
                    $('.site-header').stop().animate({
                        height:'100px'
                    },600);
                }
            }
        });

*/


        var scroll_start = 0;
        var icon_changed = false;


            $(document).scroll(function() {
                scroll_start = $(this).scrollTop();

                if(scroll_start > 20) {
                    $('.site-header').removeClass('shrink');
                    $('.site-header').addClass('shrinked');
                } else if( scroll_start <= 20) {
                    $('.site-header').removeClass('shrinked');
                    $('.site-header').addClass('shrink');
                }

                if ( $('.site-header').hasClass('frontpage') ) {
                    if (scroll_start > 350) {
                        $('.site-header').find('input').show();
                        $('.site-header').find('.btn-search').show();
                    } else if (scroll_start <= 350) {
                        $('.site-header').find('input').hide();
                        $('.site-header').find('.btn-search').hide();
                    }
                }
            });

        /* Page feedback */
        $('#show-page-feedback-button').on('click', function() {
            $('.page-feedback-form-wrapper').css('border', '1px solid rgba(30, 30, 30, 0.1)' );
            $('.gform_wrapper').slideDown();
            $(this).attr('disabled', 'disabled');
        });


        /* Page feedback */
        if( $('.gform_confirmation_message').length ) {
            $('#show-page-feedback-button').hide();
        }


        /* Page tracker for search filter */
        if (typeof(Storage) !== "undefined") {

            if (typeof localStorage.visitedPagesStorage === 'undefined') {
                localStorage.visitedPagesStorage = "[]";
            }

            var pageId = $('meta[name="pageid"]').attr("content");
            pageId = parseInt(pageId);

            var visitedPages = JSON.parse(localStorage.visitedPagesStorage);
            var isPageIdSet = pageId !== null && !isNaN(pageId);

            if (isPageIdSet && visitedPages.indexOf(pageId) === -1) {

                visitedPages.push(pageId);
                localStorage.visitedPagesStorage = JSON.stringify(visitedPages);
            }

        }
        else {
            console.log("This browser does not support local storage, search filter on visited pages will no work");
        }



	});

})(jQuery);